import { openBlock as e, createElementBlock as a, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M4.887 2.521a.75.75 0 0 1 .683-.441h4.84a.75.75 0 0 1 .684.441l.103.228a592.165 592.165 0 0 0 .363.801h1.58v1.18h-.23.23v.32-.32h1.27v8.43a.75.75 0 0 1-.75.75H2.85c-.295 0-.587-.094-.82-.271a1.109 1.109 0 0 1-.45-.879V4.7c0-.802.757-1.15 1.27-1.15h.388a.75.75 0 0 1 .122-.01h1.066l.46-1.019ZM3.492 5.04a.751.751 0 0 1-.122.01h-.29v7.36h9.83V5.05h-1.83a.752.752 0 0 1-.658-.39l-.014-.027a1.14 1.14 0 0 1-.04-.083l-.079-.172-.23-.507-.133-.291H6.054l-.46 1.019a.75.75 0 0 1-.684.441H3.492Zm10.168-.31h.75c0-.79-.726-1.18-1.27-1.18v1.18h.52ZM8 7.3a1.42 1.42 0 1 0 0 2.84A1.42 1.42 0 0 0 8 7.3ZM5.08 8.72a2.92 2.92 0 1 1 5.84 0 2.92 2.92 0 0 1-5.84 0Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  l
];
function h(n, r) {
  return e(), a("svg", o, [...c]);
}
const s = { render: h };
export {
  s as default,
  h as render
};
